import React from 'react';
import '../Colors.css';

const BicycleBoxed = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 283.465 283.632" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='Citybike' d="M0.015,35.174c0-19.132,15.943-35.075,35.075-35.075h212.576c19.841,0,35.784,15.943,35.784,35.075V247.75
      c0,19.84-15.943,35.784-35.784,35.784H35.09c-19.132,0-35.075-15.943-35.075-35.784V35.174z"/>
      <path className='Black' d="M99.757,129.276c10.102,8.012,16.372,20.204,16.372,34.138c0,24.384-19.508,43.891-43.891,43.891
      c-24.384,0-43.892-19.507-43.892-43.891c0-24.036,19.508-43.891,43.892-43.891c2.089,0,4.18,0,6.27,0.349l-3.832,8.709h-2.438
      c-19.159,0-34.835,15.676-34.835,34.834c0,19.159,15.676,34.835,34.835,34.835c19.158,0,34.834-15.676,34.834-34.835
      c0-10.102-4.18-19.159-11.146-25.429L99.757,129.276z M211.227,167.942h-61.657c-1.742,0-3.136-0.697-3.832-1.393l-48.071-50.162
      l-21.249,48.768c-0.696,1.742-2.438,2.787-4.18,2.787c-0.697,0-1.046,0-1.742-0.349c-2.439-1.045-3.483-3.483-2.439-5.922
      l35.879-82.557c0.697-1.742,2.09-2.787,3.832-2.787h13.237c2.787,0,4.529,2.09,4.529,4.529c0,2.438-1.742,4.528-4.529,4.528
      h-10.102l-4.877,10.799h66.882l4.877-11.147h-10.45c-4.18,0-8.36-4.529-8.36-8.709h43.195c0,4.18-4.181,8.709-8.709,8.709h-5.922
      l-10.798,25.777l37.97,49.813c1.045,1.393,1.045,3.135,0.348,4.877C214.362,166.897,212.969,167.942,211.227,167.942z
       M148.176,155.75l21.249-50.51h-67.23l-0.696,2.09L148.176,155.75z M156.537,158.885h45.285l-29.261-38.318L156.537,158.885z
       M255.118,163.413c0,24.384-19.855,43.891-43.891,43.891c-20.205,0-37.273-13.585-42.499-32.047h9.406
      c4.877,13.237,17.766,22.991,33.093,22.991c19.158,0,34.834-15.676,34.834-34.835c0-19.159-15.676-34.834-34.834-34.834
      c-3.832,0-7.315,0.697-10.799,1.742l-5.922-7.664c5.225-2.09,10.799-3.135,16.721-3.135
      C235.263,119.522,255.118,139.377,255.118,163.413z M168.729,151.918c1.394-5.574,4.181-10.45,7.315-14.979l5.922,7.315
      c-1.742,2.438-2.787,4.877-3.832,7.664H168.729z"/>
    </svg>
  );
};

export default BicycleBoxed;